import TableWin from './TableWin';

export default TableWin;
